<template>
	<main id="main">
		<UploadOptionFilter @toggle-filter="toggleFilter(false)" />
		<UploadOptionList @toggle-filter="toggleFilter(true)" />
	</main> 
</template>

<script setup>
import UploadOptionList from "./UploadOptionList.vue"
import UploadOptionFilter from "./UploadOptionFilter.vue"

const toggleFilter = (flag) => {
	var sideMenu = document.getElementById('sideMenu');
	if (flag) { //open filter
		sideMenu.style.transition = 'left 0.5s';
		sideMenu.style.left = '0';
	} else { //close filter
		sideMenu.style.left = '-450px';
	}
}
</script>
<style scoped src="@/assets/css/pc/upload.css">
</style>